import jsCookie from "js-cookie";
const TokenKey = "LUCKY_CARD_TOKEN";
const days = 30;

// 获取token
export function getToken() {
  return jsCookie.get(TokenKey);
}

// 设置token
export function setToken(token, remmberMe) {
  if (remmberMe) {
    // expires设置保存token多长时间
    return jsCookie.set(TokenKey, token, { expires: days });
  } else {
    return jsCookie.set(TokenKey, token);
  }
}

// 删除token
export function removeToken() {
  return jsCookie.remove(TokenKey);
}
